import CookieHelper from '@/modules/core/app/helpers/CookieHelper';
import { getters } from '/@/modules/core/app/helpers/store';
import { EnvValueSetting } from '@/modules/auth/models/interfaces/EnvValueSetting';

export abstract class BaseEnv {
  // npmPackageVersion = import.meta.env.npm_package_version;
  npmPackageVersion = '1.0.0';

  envValues?: EnvValueSetting;

  computedEnv?: ImportMetaEnv & EnvValueSetting;

  abstract nodeEnv(): ImportMetaEnv & EnvValueSetting;

  setEnvValues(envValues: EnvValueSetting): void {
    this.envValues = envValues;
    this.computedEnv = undefined;
    this.nodeEnv();
  }

  env(): EnvValueSetting {
    return this.envValues || ({} as EnvValueSetting);
  }

  /**
   * @returns {boolean}
   */
  isLocal(): boolean {
    return this.nodeEnv().MODE === 'development';
  }

  /**
   * @returns {boolean}
   */
  isStaging(): boolean {
    return this.nodeEnv().MODE === 'staging';
  }

  /**
   * @returns {boolean}
   */
  isSandbox(): boolean {
    return this.nodeEnv().MODE === 'sandbox';
  }

  /**
   * @returns {boolean}
   */
  isUat(): boolean {
    return this.nodeEnv().MODE === 'uat';
  }

  /**
   * @returns {boolean}
   */
  isDeployed(): boolean {
    return this.isStaging() || this.isSandbox() || this.isUat() || this.isProduction();
  }

  /**
   * @returns {boolean}
   */
  isProduction(): boolean {
    return this.nodeEnv().MODE === 'production';
  }

  /**
   * @returns {boolean}
   */
  isDevelopment(): boolean {
    return this.isLocal() || this.isStaging();
  }

  /**
   * @return {boolean}
   */
  isServerSideRendering(): boolean {
    if (!this.isBrowser()) {
      return true;
    }

    try {
      // @ts-ignore
      return !!getters.export.getRawJson();
    } catch (e) {
      return false;
    }
  }

  isBrowser(): boolean {
    try {
      window;
      return true;
    } catch (e) {
      return false;
    }
  }

  isPlaywrightNode(): boolean {
    if (!this.nodeEnv().IS_RUNNING_END_2_END) {
      return false;
    }

    return !this.isBrowser();
  }

  isRunningUnitTest(): boolean {
    return this.nodeEnv().VITEST === 'true';
  }

  isRunningStorybook(): boolean {
    return this.nodeEnv().STORYBOOK === 'true';
  }

  /**
   * @returns {boolean}
   */
  isRunningCypress(): boolean {
    return (
      this.nodeEnv().VITE_APP_CYPRESS === 'true' ||
      CookieHelper.get('is_running_playwright') === 'true'
    );
  }

  getAppVersion(): string {
    if (this.isLocal()) {
      return 'dev';
    }

    return this.nodeEnv().VITE_APP_RELEASE_VERSION ?? '';
  }

  getAppPath(): string {
    return this.nodeEnv().VITE_APP_PATH;
  }

  getMetaAppId(): string {
    return this.nodeEnv().VITE_META_APP_ID;
  }
}
